import { render, staticRenderFns } from "./MessageQueueDeadLetters.vue?vue&type=template&id=402bddfb"
import script from "./MessageQueueDeadLetters.vue?vue&type=script&lang=js"
export * from "./MessageQueueDeadLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports